import runReference from "../../../references/run-reference";

/**
 *
 * @param {StepProps | TimelineMapProps} step
 * @param {Boolean} enter
 * @param {"start" | "finish"} hook
 * @param {"started" | "finished"} mode
 * @param {-1 | 0 | 1} isActive
 */
const onStatusCycle = (step, enter, hook, mode, isActive = 0) => {
  const started = mode === "started" ? "started" : "finished";
  const finished = mode === "started" ? "finished" : "started";

  step.set(started, true);
  step.set(finished, false);

  /** Reference `on|start` hook */
  if (step.get(`has-${hook}-hook`)) {
    const reference = /** @type {String} */ (step.get(`o_on_-_${hook}`));

    runReference(enter, reference);
  }

  if (isActive === 1) {
    step.set("is-active", true);
  }
  if (isActive === -1) {
    step.set("is-active", false);
  }
};

export default onStatusCycle;
